var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareersCuttingEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 37.5C22.2673 37.5015 20.5613 37.0736 19.0345 36.2546C17.5076 35.4355 16.2076 34.2509 15.2505 32.8065L17.7495 31.146C18.4336 32.1776 19.3624 33.0238 20.453 33.6092C21.5436 34.1946 22.7622 34.501 24 34.501C25.2378 34.501 26.4564 34.1946 27.547 33.6092C28.6376 33.0238 29.5664 32.1776 30.2505 31.146L32.7495 32.8065C31.7925 34.2509 30.4924 35.4355 28.9655 36.2546C27.4387 37.0736 25.7327 37.5015 24 37.5ZM30 21C29.4067 21 28.8266 21.176 28.3333 21.5056C27.8399 21.8353 27.4554 22.3038 27.2284 22.852C27.0013 23.4002 26.9419 24.0034 27.0576 24.5853C27.1734 25.1672 27.4591 25.7018 27.8787 26.1214C28.2982 26.5409 28.8328 26.8266 29.4147 26.9424C29.9967 27.0581 30.5999 26.9987 31.1481 26.7717C31.6962 26.5446 32.1648 26.1601 32.4944 25.6667C32.8241 25.1734 33 24.5934 33 24C33.004 23.605 32.9292 23.213 32.7798 22.8473C32.6305 22.4815 32.4096 22.1491 32.1303 21.8698C31.8509 21.5904 31.5186 21.3696 31.1528 21.2202C30.787 21.0709 30.3951 20.996 30 21ZM18 21C17.4067 21 16.8266 21.176 16.3333 21.5056C15.8399 21.8353 15.4554 22.3038 15.2284 22.852C15.0013 23.4002 14.9419 24.0034 15.0576 24.5853C15.1734 25.1672 15.4591 25.7018 15.8787 26.1214C16.2982 26.5409 16.8328 26.8266 17.4147 26.9424C17.9967 27.0581 18.5999 26.9987 19.1481 26.7717C19.6962 26.5446 20.1648 26.1601 20.4944 25.6667C20.8241 25.1734 21 24.5934 21 24C21.004 23.605 20.9292 23.213 20.7798 22.8473C20.6305 22.4815 20.4096 22.1491 20.1303 21.8698C19.8509 21.5904 19.5186 21.3696 19.1528 21.2202C18.787 21.0709 18.3951 20.996 18 21Z",
    fill: "url(#paint0_linear_1235_8184)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24V21H42V15C41.998 13.4093 41.3652 11.8843 40.2404 10.7596C39.1157 9.63476 37.5907 9.00198 36 9H33V3H30V9H18V3H15V9H12C10.4093 9.00198 8.88434 9.63476 7.75955 10.7596C6.63476 11.8843 6.00198 13.4093 6 15V21H3V24H6V31.5H3V34.5H6V39C6.00198 40.5907 6.63476 42.1157 7.75955 43.2404C8.88434 44.3652 10.4093 44.998 12 45H36C37.5907 44.998 39.1157 44.3652 40.2404 43.2404C41.3652 42.1157 41.998 40.5907 42 39V34.5H45V31.5H42V24H45ZM39 39C38.9992 39.7954 38.6829 40.558 38.1204 41.1204C37.558 41.6829 36.7954 41.9992 36 42H12C11.2046 41.9992 10.442 41.6829 9.87956 41.1204C9.31712 40.558 9.00079 39.7954 9 39V15C9.00079 14.2046 9.31712 13.442 9.87956 12.8796C10.442 12.3171 11.2046 12.0008 12 12H36C36.7954 12.0008 37.558 12.3171 38.1204 12.8796C38.6829 13.442 38.9992 14.2046 39 15V39Z",
    fill: "url(#paint1_linear_1235_8184)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235_8184",
    x1: 7.43617,
    y1: 10.9822,
    x2: 41.7621,
    y2: 45.9437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1235_8184",
    x1: -0.191805,
    y1: 3,
    x2: 45,
    y2: 51.9827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersCuttingEdge);
export default __webpack_public_path__ + "static/media/Careers_Cutting_Edge.978dffc64606a0fa76f85eecec84683b.svg";
export { ForwardRef as ReactComponent };